import { ProcessState } from "./models";
import { makeAutoObservable, runInAction } from "mobx";
export class JobPanelStoreImpl {
    constructor(rootStore, serviceClient) {
        this.jobPanels = [];
        this.loadState = ProcessState.LOADING;
        this.selectedEntry = null;
        this.uploadState = ProcessState.NONE;
        this.deleteState = ProcessState.NONE;
        makeAutoObservable(this);
        this.serviceClient = serviceClient;
        this.rootStore = rootStore;
    }
    loadJobPanels() {
        this.serviceClient
            .then((client) => client.apis.job_panel.getJobPanels({}, {}))
            .then((response) => {
            runInAction(() => {
                this.loadState = ProcessState.SUCCESS;
                this.jobPanels = response.body;
            });
        })
            .catch((error) => {
            runInAction(() => {
                this.loadState = ProcessState.SUCCESS;
                this.rootStore.notificationStore.handleError(error);
            });
        });
    }
    addJobPanelEntry(file) {
        this.uploadState = ProcessState.LOADING;
        this.serviceClient
            .then((client) => client.apis.job_panel.addJobPanelEntry({}, { requestBody: { file: file } }))
            .then((response) => {
            const taskData = response.body;
            const onSuccess = () => {
                this.loadJobPanels();
                runInAction(() => {
                    this.uploadState = ProcessState.SUCCESS;
                });
            };
            const onError = (error) => {
                this.rootStore.notificationStore.enqueueSnackbar("Fehler beim Hochladen: " + error);
                runInAction(() => {
                    this.uploadState = ProcessState.ERROR;
                });
            };
            this.monitorTaskId(taskData.taskId, onSuccess, onError);
        })
            .catch((error) => {
            this.uploadState = ProcessState.ERROR;
            this.rootStore.notificationStore.handleError(error);
        });
    }
    setSelectedEntry(entry, panelId) {
        if (entry) {
            let extendedEntry = Object.assign({}, entry);
            extendedEntry["panelId"] = panelId;
            runInAction(() => {
                this.selectedEntry = extendedEntry;
            });
        }
        else {
            runInAction(() => {
                this.selectedEntry = null;
            });
        }
    }
    deleteJobPanelEntry(panelId) {
        this.deleteState = ProcessState.LOADING;
        this.serviceClient
            .then((client) => client.apis.job_panel.deleteJobPanel({ panelId: panelId }))
            .then((response) => {
            const taskData = response.body;
            const onSuccess = () => {
                this.loadJobPanels();
                runInAction(() => {
                    this.deleteState = ProcessState.SUCCESS;
                });
            };
            const onError = (error) => {
                this.rootStore.notificationStore.enqueueSnackbar("Fehler beim Löschen: " + error);
                runInAction(() => {
                    this.deleteState = ProcessState.ERROR;
                });
            };
            this.monitorTaskId(taskData.taskId, onSuccess, onError);
        })
            .catch((error) => {
            this.deleteState = ProcessState.ERROR;
            this.rootStore.notificationStore.handleError(error);
        });
    }
    getJobPanel(panelId) {
        let panels = this.jobPanels.filter((panel) => panel.id == panelId);
        if (panels) {
            return panels[0];
        }
        return null;
    }
    monitorTaskId(taskId, onSuccess, onFailure) {
        this.serviceClient
            .then((client) => client.apis.task.getTaskStatus({ taskId: taskId }, {}))
            .then((response) => {
            const taskStatus = response.body;
            if (taskStatus.isPending) {
                setTimeout(() => {
                    this.monitorTaskId(taskId, onSuccess, onFailure);
                }, 3000);
            }
            else if (taskStatus.isFinishedSuccess) {
                onSuccess();
            }
            else {
                onFailure(taskStatus.result);
            }
        })
            .catch((error) => {
            onFailure(error);
        });
    }
}
